<template>
  <div class="form-wizard-page">
    <div class="va-row">
      <div class="flex md12">
        <vuestic-widget class="no-h-padding" :headerText="$t('trip.create.title')">
          <vuestic-wizard
            :steps="allSteps"
            :lastStepLabel="$t('trip.create.createButton')"
            :wizardCompletedSlotName="'pageTripCreated'"
            @wizardComplete="createTrip()"
          >
            <div slot="pageTripName" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div
                class="form-group with-icon-right"
                :class="{'has-error': errors.has('tripName'), 'valid': isFormFieldValid('tripName')}"
              >
                <div class="input-group">
                  <input
                    name="tripName"
                    data-vv-as="tripName"
                    v-model="tripName"
                    v-validate="'required'"
                    required
                    title
                  />
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">
                    {{'trip.create.nameField' | translate}}
                  </label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('tripName')"
                    class="help text-danger"
                  >{{ errors.first('tripName') != null ? errors.first('tripName').replace('tripName', $t('trip.create.nameField').toLowerCase()) : "" }}</small>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('general.price')"
                    :clearable="false"
                    v-model="currency"
                    data-vv-name="currency"
                    v-validate="'required'"
                    data-vv-validate-on="change|input"
                    :options="currencyList"
                    option-key="id"
                  ></vuestic-simple-select>
                </div>
              </div>
            </div>

            <div slot="pageTripDuration" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p>{{$t('trip.create.durationTitle')}}</p>
              </div>
              <div>
                <div class="form-group">
                  <div class="input-group">
                    <vuestic-date-picker
                      id="tripDurationFrom"
                      :config="config.tripDateFrom"
                      ref="tripDurationFrom"
                      v-model="tripDurationFrom"
                      v-validate="'required'"
                      data-vv-name="tripDurationFrom"
                      data-vv-validate-on="change|input"
                      @on-change="onTripDateFromChange"
                    />
                    <label
                      class="control-label"
                      for="tripDurationFrom"
                    >{{ $t('trip.create.durationFrom') }}</label>
                    <i class="bar"></i>
                  </div>
                </div>

                <div class="form-group">
                  <div class="input-group">
                    <vuestic-date-picker
                      id="tripDurationTo"
                      :config="config.tripDateTo"
                      ref="tripDurationTo"
                      v-model="tripDurationTo"
                      v-validate="'required'"
                      data-vv-name="tripDurationTo"
                      data-vv-validate-on="change|input"
                      @on-change="onTripDateToChange"
                    />
                    <label
                      class="control-label"
                      for="tripDurationTo"
                    >{{ $t('trip.create.durationTo') }}</label>
                    <i class="bar"></i>
                  </div>
                </div>

                <small
                  v-show="errors.has('tripDurationTo')"
                  class="help text-danger"
                >{{ $t('trip.create.durationErrorТо') }}</small>

                <small
                  v-show="errors.has('tripDurationFrom')"
                  class="help text-danger"
                >{{ $t('trip.create.durationErrorFrom') }}</small>

                <small
                  v-show="errors.has('tripDurationTo') && errors.has('tripDurationFrom')"
                  class="help text-danger"
                >{{ $t('trip.create.durationError') }}</small>
                <!-- <pre>{{ errors.items.map(e => e.msg) }}</pre>  -->
              </div>
            </div>

            <div slot="pageTripPrice" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>

              <div class="form-group va-row pb-4">
                <div class="input-group md3 flex offset--md3 no-padding mr-1">
                  <input
                    data-vv-name="tripPrice"
                    v-model="tripPrice"
                    v-validate="'required|numeric:point'"
                    required
                  />
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'trip.create.priceField' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('tripPrice')"
                    class="help text-danger"
                  >{{ errors.first('tripPrice') != null ? errors.first('tripPrice').replace('tripPrice',$t('trip.create.priceField').toLowerCase()) : "" }}</small>
                </div>
                <div class="md3 flex no-padding currency">{{ $t("general.currency." + tripCurrency + ".long") }}</div>
              </div>
              <div class="form-group va-row">
                <div class="input-group md3 flex offset--md3 no-padding mr-1">
                  <input
                    class
                    data-vv-name="tripDeposit"
                    v-model="tripDeposit"
                    v-validate="'numeric:point'"
                    required
                  />
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'trip.create.depositField' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('tripDeposit')"
                    class="help text-danger"
                  >{{ errors.first('tripDeposit') != null ? errors.first('tripDeposit').replace('tripDeposit',$t('trip.create.depositField').toLowerCase()) : "" }}</small>
                </div>
                <div class="md3 flex no-padding currency">{{ $t("general.currency." + tripCurrency + ".long") }}</div>
              </div>
            </div>

            <div slot="pageTripDestination" class="form-wizard-tab-content">
              <div class="form-group">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('trip.create.destinationField')"
                    :clearable="false"
                    v-model="tripDestination"
                    data-vv-name="tripDestination"
                    v-validate="'required'"
                    data-vv-validate-on="change|input"
                    ref="tripDestinationRef"
                    option-key="name"
                    v-bind:options="tripDestionationList"
                  ></vuestic-simple-select>
                  <small v-show="errors.has('tripDestination')" class="help text-danger">
                    {{ errors.first('tripDestination') != null ? errors.first('tripDestination').replace('tripDestination', $t('trip.create.destinationField').toLowerCase()) : ""
                    }}
                  </small>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('general.passportField')"
                    :clearable="false"
                    v-model="mandatoryPassport"
                    name="mandatoryPassport"
                    data-vv-name="mandatoryPassport"
                    v-validate="'required'"
                    data-vv-validate-on="change|input"
                    ref="mandatoryPassport"
                    v-bind:options="mandatoryOptions"
                    option-key="label"
                  ></vuestic-simple-select>
                  <small
                    v-show="errors.has('mandatoryPassport')"
                    class="help text-danger"
                  >{{ errors.first('mandatoryPassport') != null ? errors.first('mandatoryPassport').replace('mandatoryPassport', $t('general.passportField').toLowerCase()) : "" }}</small>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <vuestic-simple-select
                    :label="$t('general.visaField')"
                    :clearable="false"
                    v-model="mandatoryVisa"
                    name="mandatoryVisa"
                    data-vv-name="mandatoryVisa"
                    v-validate="'required'"
                    data-vv-validate-on="change|input"
                    ref="mandatoryVisa"
                    v-bind:options="mandatoryOptions"
                    option-key="label"
                  ></vuestic-simple-select>
                  <small
                    v-show="errors.has('mandatoryVisa')"
                    class="help text-danger"
                  >{{errors.first('mandatoryVisa') != null ? errors.first('mandatoryVisa').replace('mandatoryVisa', $t('general.visaField').toLowerCase()) : "" }}</small>
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <input
                    data-vv-name="tripParticipants"
                    v-model="tripParticipants"
                    v-validate="{ required: true, regex: /^(?=.*[1-9])\d+(\.\d+)?$/ }"
                    required
                  />
                  <i class="fa fa-exclamation-triangle error-icon icon-right input-icon"></i>
                  <i class="fa fa-check valid-icon icon-right input-icon"></i>
                  <label class="control-label">{{'trip.create.participants' | translate}}</label>
                  <i class="bar"></i>
                  <small
                    v-show="errors.has('tripParticipants')"
                    class="help text-danger"
                  >{{ errors.first('tripParticipants') != null ? errors.first('tripParticipants').replace('tripParticipants',$t('trip.create.participants').toLowerCase()) : "" }}</small>
                </div>
              </div>
            </div>

            <div slot="pageTripDocuments" class="form-wizard-tab-content">
              <div class="form-wizard-tab-content-text">
                <p></p>
              </div>
              <div class="md2">
                <fieldset>
                  <div class="form-group form-group-w-btn va-row flex text-center">
                    <div class="input-group md6">
                      <label>{{$t('trip.create.templateFiled')}}</label>
                      <button class="btn btn-secondary info-btn" @click="showModal()">
                        <i class="ion-md-information-circle ion"></i>
                      </button>
                      <vuestic-file-upload
                        type="single"
                        :file-types="'.docx'"
                        data-vv-name="tripContractTemplate"
                        v-validate="'required'"
                        v-model="tripContractTemplate"
                        
                      />
                    </div>
                    <small
                      v-show="errors.has('tripContractTemplate')"
                      class="help text-danger"
                    >{{ errors.first('tripContractTemplate') != null ? errors.first('tripContractTemplate').replace('tripContractTemplate',$t('trip.create.templateFiled')) : "" }}</small>
                    <div class="spacer"></div>
                    <div class="input-group md6">
                      <label>{{$t('trip.create.documentFiled')}}</label>
                      <vuestic-file-upload
                        type="single"
                        :file-types="'.docx,.pdf'"
                        v-model="tripDetailsDocument"
                        data-vv-name="tripDetailsDocument"
                        v-validate="'required'"
                      />
                      <small
                        v-show="errors.has('tripDetailsDocument')"
                        class="help text-danger"
                      >{{ errors.first('tripDetailsDocument') != null ? errors.first('tripDetailsDocument').replace('tripDetailsDocument',$t('trip.create.documentFiled')) : "" }}</small>
                    </div>
                  </div>
                </fieldset>
              </div>
            </div>

            <div slot="wizardCompleted" class="form-wizard-tab-content">
              <div class="text-center" v-show="isCreateSuccessful">
                <h4>{{'trip.create.completedTitle' | translate}}</h4>
                <div>
                  <button
                    type="button"
                    class="btn btn-micro btn-primary mr-4"
                    @click="$router.push(`details/${tripId}`)"
                  >{{ $t("trip.create.toDetails") }}</button>
                  <button
                    type="button"
                    class="btn btn-micro btn-primary"
                    @click="$router.push({name: 'add-traveller', query:{ tripId: `${tripId}` }})"
                  >{{ $t("preview.addTraveler") }}</button>
                </div>
              </div>
              <div class="text-center" v-show="!isCreateSuccessful">
                <h4>{{'trip.create.failedTitle' | translate}}</h4>
                <p>{{'trip.create.failedText' | translate}}</p>
              </div>
            </div>
          </vuestic-wizard>
          <!--//Modals-->
          <vuestic-modal
            ref="smallModal"
            v-bind:medium="true"
            :cancelClass="'none'"
            :okText="'modal.confirm' | translate"
            :cancelText="'modal.cancel' | translate"
          >
            <div slot="title">{{'modal.info' | translate}}</div>
            <p>
              Моля, използвайте следната таблица с кодове, когато създавате шаблон за договор. На всяко място където
              изпозлвате кода в договара, системата ще се опита да постави стойност от профила на потребителя или от данните за пътуването, ако такава съществува.
              Форматирането на самия договор ще се запази. При натискане на бутона се копира съответния код и той трябва да се вмъкне в договора.
            </p>
            <p>
              Това ще помогне за правилното генериране на договори
              за всеки клиент и ще спести значително време от ръчното попълване на данни за всеки потребител.
            </p>
            <div class="table-responsive">
              <table class="table table-striped first-td-padding">
                <thead>
                  <tr>
                    <td class="filters-page__table-heading">{{'modal.placeholder' | translate}}</td>
                    <td class="filters-page__table-heading">{{'modal.explanation' | translate}}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('name')"
                      >Имена</button>
                    </td>
                    <td>Пълно име</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('nameLatin')"
                      >Латински имена</button>
                    </td>
                    <td>Пълно име на латински</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('identityNumber')"
                      >ЕГН</button>
                    </td>
                    <td>ЕГН</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('phone')"
                      >телефон</button>
                    </td>
                    <td>Телефон</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('email')"
                      >email</button>
                    </td>
                    <td>email</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('identityCardNumber')"
                      >Лична Карта</button>
                    </td>
                    <td>Номер на лична карта</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('identityCardIssuer')"
                      >ЛК издадена от</button>
                    </td>
                    <td>Издател на лична карта</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('identityCardCreationDate')"
                      >ЛК издадена на</button>
                    </td>
                    <td>Дата на издаване на лична карта</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('identityCardExpirationDate')"
                      >ЛК валидна до</button>
                    </td>
                    <td>Дата до която е валидна личната карта</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('passportNumber')"
                      >Паспорт</button>
                    </td>
                    <td>Номер на паспорт</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('passportCreationDate')"
                      >Паспорт издадена на</button>
                    </td>
                    <td>Дата на издаване на паспорт</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('passportExpirationDate')"
                      >Паспорт валиден до</button>
                    </td>
                    <td>Дата до която е валиден паспорта</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripStartDate')"
                      >Пътуване начало</button>
                    </td>
                    <td>Дата на която започва пътуването</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripEndDate')"
                      >Пътуване край</button>
                    </td>
                    <td>Дата на която завършва пътуването</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripPrice')"
                      >Пътуване цена</button>
                    </td>
                    <td>Цена на пътуването</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripDeposit')"
                      >Пътуване капаро</button>
                    </td>
                    <td>Капаро за съответното пътуване</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripTitle')"
                      >Пътуване име</button>
                    </td>
                    <td>Име на пътуването, както е въведено в системата</td>
                  </tr>
                  <tr>
                    <td>
                      <button
                        class="btn btn-secondary btn-micro"
                        @click="copyTemplate('tripKey')"
                      >Пътуване код</button>
                    </td>
                    <td>Уникален код на пътуването, както е генериран от системата</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </vuestic-modal>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { baseUrl, host } from "../../../services/http";
import { tripApi } from "../../../services/api/tripApi";
import utils from "../../../services/utils";
import moment from "moment";
import { dateLocale, serverDateLocale, copyTextToClipboard, fallbackCopyTextToClipboard } from "../../../utils";

export default {
  name: "register",

  computed: {
    allSteps() {
      return [
        {
          label: this.$t("trip.create.nameTitle"),
          slot: "pageTripName",
          onNext: () => {
            this.validateFormField("tripName");
          },
          isValid: () => {
            return this.isFormFieldValid("tripName");
          }
        },

        {
          label: this.$t("trip.create.durationTitle"),
          slot: "pageTripDuration",
          onNext: () => {
            this.validateFormField("tripDurationFrom");
            this.validateFormField("tripDurationTo");
          },
          isValid: () => {
            return (
              this.isFormFieldValid("tripDurationFrom") &&
              this.isFormFieldValid("tripDurationTo")
            );
          }
        },

        {
          label: this.$t("trip.create.priceTitle"),
          slot: "pageTripPrice",
          onNext: () => {
            this.validateFormField("tripPrice");
            this.validateFormField("tripDeposit");

            let data = utils.gather.call(this, ["tripPrice", "tripDeposit"]);

            // console.log("Obj: ", data);
          },
          isValid: () => {
            return (
              this.isFormFieldValid("tripPrice") &&
              this.isFormFieldValid("tripDeposit")
            );
          }
        },

        {
          label: this.$t("trip.create.documentsTitle"),
          slot: "pageTripDocuments",
          onNext: () => {},
          isValid: () => {
            return true;
          }
        },

        {
          label: this.$t("trip.create.destinationTitle"),
          slot: "pageTripDestination",
          onNext: () => {
            this.validateFormField("tripDestination");
            this.validateFormField("mandatoryPassport");
            this.validateFormField("mandatoryVisa");
            this.validateFormField("tripParticipants");
          },
          isValid: () => {
            return (
              this.isFormFieldValid("tripDestination") &&
              this.isFormFieldValid("mandatoryPassport") &&
              this.isFormFieldValid("mandatoryVisa") &&
              this.isFormFieldValid("tripParticipants")
            );
          }
        }
      ];
    },
    tripCurrency() {
      return this.currency && this.currency.id ? this.currency.id.toLowerCase() : 'bgn';
    }
  },
  data() {
    return {
      tripId: null,
      tripName: "",
      tripDurationFrom: "",
      tripDurationTo: "",
      tripPrice: "",
      tripDeposit: "",
      tripDestination: "",
      tripDestionationList: [
        { id: "BG", name: "България" },
        { id: "EU", name: "EU" },
        { id: "OT", name: "Друго" }
      ],
      mandatoryOptions: [
        { label: this.$t("general.yes"), value: 1 },
        { label: this.$t("general.no"), value: 0 }
      ],
      mandatoryVisa: null,
      mandatoryPassport: null,
      tripContractTemplate: [],
      tripDetailsDocument: [],
      tripParticipants: "",
      isLoading: false,
      isCreateSuccessful: false,
      currencyList: [
        { id: 'EUR', name: 'EUR' },
        { id: 'BGN', name: 'BGN' }
      ],
      currency: { id: 'EUR', name: 'EUR' },

      config: {
        tripDateFrom: {
          dateFormat: "d-m-Y",
          locale: { firstDayOfWeek: 1 },
          minDate: new Date(),
          maxDate: null
        },
        tripDateTo: {
          dateFormat: "d-m-Y",
          locale: { firstDayOfWeek: 1 },
          minDate: null
        }
      }
    };
  },
  methods: {
    isFormFieldValid(field) {
      let isValid = false;
      if (this.formFields[field]) {
        isValid =
          this.formFields[field].validated && this.formFields[field].valid;
      }
      return isValid;
    },
    validateFormField(fieldName) {
      this.$validator.validate(fieldName, this[fieldName]);
    },

    onTripDateFromChange(selectedDates, dateStr, instance) {
      this.$set(this.config.tripDateTo, "minDate", dateStr);
    },

    onTripDateToChange(selectedDates, dateStr, instance) {
      this.$set(this.config.tripDateFrom, "maxDate", dateStr);
    },

    createTrip() {
      this.isLoading = true;
      let tripId = null;
      return tripApi
        .create({
          title: this.tripName,
          startDate: moment(this.tripDurationFrom, dateLocale).format(
            serverDateLocale
          ),
          endDate: moment(this.tripDurationTo, dateLocale).format(
            serverDateLocale
          ),
          price: this.tripPrice,
          currency: this.currency && this.currency.id ? this.currency.id : 'EUR',
          destinationType: this.tripDestination.id,
          deposit: this.tripDeposit,
          participants: this.tripParticipants,
          requirePassport: this.mandatoryPassport.value,
          requireVisa: this.mandatoryVisa.value
        })
        .then(trip => {
          this.tripId = trip.id;
          this.uploadCotract(this.tripContractTemplate);
          this.uploadTripDetails(this.tripDetailsDocument);
        })
        .then(() => {
          this.isCreateSuccessful = true;
        })
        .catch(e => {
          console.log('Error creating trip');
        })
        .finally(() => (this.isLoading = false));
    },

    uploadCotract(docRepo){
      this.uploadDocument(1,docRepo)
      .then(document => {
          return tripApi.linkContract(this.tripId, document.id);
      });
    },

    uploadTripDetails(docRepo){
      this.uploadDocument(0,docRepo)
      .then(document => {
          return tripApi.linkTripDetails(this.tripId, document.id);
      });
    },

    uploadDocument(docType, docRepo) {
      if (docRepo.length > 0) {
        return tripApi
          .uploadDocument({
            documentType: docType,
            document: docRepo[0]
        });
      }
      return Promise.reject();
    },

    showModal() {
      this.$refs.smallModal.open();
    },

    copyTemplate(name) {  
      copyTextToClipboard("{" + name + "}");
    }
  }
};
</script>

<style lang="scss">
.form-wizard-page {
  .wizard-body-actions .btn-container {
    margin-right: 4rem;
    margin-top: 1.5rem;
  }

  .currency {
    display: flex;
    align-self: flex-end;
  }

  .no-padding {
    padding: unset !important;
  }
}
</style>
